import posthog from 'posthog-js';
import { SignInData } from '@services/auth/types';
import { reportAuthError } from '@services/auth/report';

export const trackLogin = ({ id, primaryRole }: SignInData) => {
  try {
    posthog?.identify(id, { primary_role: primaryRole });
    posthog?.capture('user_logged_in', { primary_role: primaryRole });
  } catch (error) {
    reportAuthError('analytics', error);
  }
};
